export const saloon1ImageOptions = {
  angle: 'saloon1',
  staticOptions: {
    Veneer: 1,
    Floorboards: 1,
    FabricSaloon: 1,
    Worktop: 1,
    FabricCabins: 1,
    OwnersCabinLayout: 1,
    OwnerBerth: 1,
    AftCabinLayout: 1,
    Handrails: 1,
    PleatedBlinds: 1,
    Mast: 1
  },
  mattes: [
    {
      option: 'Veneer',
      dependency: 'OwnersCabinLayout'
    },
    {
      option: 'Floorboards',
      dependency: null
    },
    {
      option: 'FabricSaloon',
      dependency: null
    },
    {
      option: 'Worktop',
      dependency: null
    },
    {
      option: 'FabricCabins',
      dependency: 'OwnersCabinLayout'
    },
    {
      option: 'Handrails',
      dependency: null
    },
    {
      option: 'PleatedBlinds',
      dependency: null
    },
    {
      option: 'Mast',
      dependency: null
    }
  ]
}



// WEBPACK FOOTER //
// ./src/XP44/views/saloon1.js